/* ============================================================
   PINSEEKER — PS INTERACTIONS v3.0
   Source: dev-homepage.md (ATC State Machine) +
           PS_Website_Style/ps-homepage-prototype.html (all JS)
   ============================================================ */

/* ── SCROLL REVEAL ── */
(function () {
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('ps-reveal--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.04, rootMargin: '0px 0px -20px 0px' });

  function observeRevealEls(root) {
    (root || document).querySelectorAll('.ps-reveal:not(.ps-reveal--visible)').forEach(el => observer.observe(el));
  }

  // IntersectionObserver callbacks fire in the same task as .observe(), so
  // a single rAF isn't enough — the browser never commits an opacity:0 paint
  // before the class is added. setTimeout pushes observation into a new task,
  // guaranteeing at least one committed frame at opacity:0.
  setTimeout(function () { observeRevealEls(); }, 50);

  // Re-observe when a section is added or reloaded in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    observeRevealEls(e.target);
  });
})();

/* ── MOBILE NAV ── */
(function () {
  const hamburger = document.getElementById('ps-hamburger');
  const mobileNav = document.getElementById('ps-mobile-nav');
  if (!hamburger || !mobileNav) return;

  function closeMobileNav() {
    hamburger.classList.remove('is-open');
    mobileNav.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
  }

  hamburger.addEventListener('click', () => {
    const isOpen = mobileNav.classList.toggle('is-open');
    hamburger.classList.toggle('is-open');
    hamburger.setAttribute('aria-expanded', String(isOpen));
  });

  document.addEventListener('click', (e) => {
    if (!hamburger.contains(e.target) && !mobileNav.contains(e.target)) {
      closeMobileNav();
    }
  });

  // Close on nav link click
  mobileNav.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMobileNav);
  });
})();

/* ── ATC STATE MACHINE (dev-homepage.md Section 04) ── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ps-atc-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('.ps-btn--atc');
      if (!btn) return;
      const formData = new FormData(form);

      if (btn.classList.contains('is-locking') || btn.classList.contains('is-acquired')) return;

      btn.classList.add('is-locking');
      btn.textContent = 'LOCKING TARGET...';

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (response.ok) {
          btn.classList.remove('is-locking');
          btn.classList.add('is-acquired');
          btn.textContent = 'TARGET ACQUIRED';
          window.dispatchEvent(new CustomEvent('ps:cart:updated'));
        } else {
          btn.classList.remove('is-locking');
          btn.textContent = 'MISSION ABORTED';
          setTimeout(() => { btn.textContent = 'ADD TO BAG'; }, 2500);
        }
      } catch (error) {
        btn.classList.remove('is-locking');
        btn.textContent = 'MISSION ABORTED';
        setTimeout(() => { btn.textContent = 'ADD TO BAG'; }, 2500);
      }

      setTimeout(() => {
        btn.classList.remove('is-acquired');
        btn.textContent = 'ADD TO BAG';
      }, 2500);
    });
  });
});

/* ── EMAIL SUBMIT ── */
(function () {
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.classList.contains('ps-email__form')) return;
    e.preventDefault();
    const btn = form.querySelector('.ps-email__btn');
    const input = form.querySelector('.ps-email__input');
    if (!btn || !input) return;
    btn.textContent = 'TRANSMISSION SENT';
    btn.style.background = 'rgba(0,255,65,0.15)';
    btn.style.color = '#00FF41';
    input.value = '';
    input.placeholder = 'COMMS CONFIRMED. STANDING BY.';
    setTimeout(() => {
      btn.textContent = 'CONFIRM COMMS';
      btn.style.background = '';
      btn.style.color = '';
      input.placeholder = 'ENTER EMAIL // AWAITING COMMS...';
    }, 3000);
  });
})();

/* ── CART COUNT UPDATE (legacy event support) ── */
window.addEventListener('ps:cart:updated', () => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      document.querySelectorAll('.ps-cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });
    })
    .catch(() => {});
});
